import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiDownload, FiArrowRight } from 'react-icons/fi';
import Boucherpopup from '../Popupform/Boucherpopup';

// Importing images from the original location
// Note: This assumes relative paths from `src/Components/Home` to `src/Components/Colleges/images`
import img1 from '../Colleges/images/cllg1 (1).png';
import img2 from '../Colleges/images/cllg1 (2).png';
import img3 from '../Colleges/images/cllg1 (3).png';
import img4 from '../Colleges/images/cllg1 (4).png';
import img5 from '../Colleges/images/cllg1 (5).png';
import img6 from '../Colleges/images/cllg1 (6).png';
import img7 from '../Colleges/images/col11.webp';
import img8 from '../Colleges/images/col8.webp';
import img9 from '../Colleges/images/col9.webp';

const collegeData = [
    { link: 'Delhi', img: img1, rank: "Ranked 11 out of 80 TOI" },
    { link: 'TamilNadu', img: img2, rank: "Ranked 150 out of 1400S" },
    { link: 'Chennai', img: img3, rank: "Ranked 609 out of 1400S" },
    { link: 'Pune', img: img4, rank: "Ranked 95 out of 1400S" },
    { link: 'Banglore', img: img5, rank: "Ranked 150 out of 1400S" },
    { link: 'Punjab', img: img6, rank: "Ranked 100 out of 1400S" },
    { link: 'Mumbai ', img: img7, rank: "Ranked 120 out of 1400S" },
    { link: 'Kolkata', img: img8, rank: "Ranked 1200 out of 1400S" },
    { link: 'Bhopal', img: img9, rank: "Ranked 259 out of 1400S" },
];

const UniversityGridSection = () => {
    const [visibleCount, setVisibleCount] = useState(6);
    const [showBoucherPopup, setShowBoucherPopup] = useState(false);

    const loadMoreCards = () => {
        setVisibleCount((prev) => prev + 3);
    };

    const handleOpenBoucherPopup = (e) => {
        if (e) e.preventDefault();
        setShowBoucherPopup(true);
    };

    const handleCloseBoucherPopup = () => {
        setShowBoucherPopup(false);
    };

    return (
        <section className="py-24 bg-gray-50 border-t border-gray-200">
            <div className="container mx-auto px-4">
                {/* Outer Border Container */}
                <div className="border-2 border-orange-200 rounded-3xl p-8 bg-white shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="text-center mb-16 max-w-3xl mx-auto">
                        <h2 className="text-3xl font-bold text-gray-800 mb-4">Top <span className="text-brand-orange">Universities/Colleges</span></h2>
                        <p className="text-gray-500 leading-relaxed">
                            Discover a curated list of prestigious universities and colleges that set the standard for global education.
                            From cutting-edge research facilities to vibrant campus life, these institutions offer everything you need.
                        </p>
                        <div className="w-24 h-1 bg-brand-orange mx-auto mt-6 rounded-full"></div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {collegeData.slice(0, visibleCount).map((item, index) => (
                            <div key={index} className="bg-gray-50 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 group">
                                <div className="relative h-48 overflow-hidden">
                                    <img src={item.img} alt={item.link} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                                    <div className="absolute top-4 left-4 bg-white/90 backdrop-blur px-3 py-1 rounded-full text-xs font-bold text-brand-orange shadow-sm">
                                        {item.rank}
                                    </div>
                                </div>

                                <div className="p-6">
                                    <h4 className="text-lg font-bold text-gray-800 mb-2">{item.link} Region</h4>

                                    <div className="space-y-3 mt-4">
                                        <div className="flex items-center justify-between text-sm pt-4 border-t border-gray-100">
                                            <button className="text-gray-600 hover:text-brand-orange font-semibold transition">
                                                Compare
                                            </button>
                                            <button onClick={handleOpenBoucherPopup} className="flex items-center text-gray-600 hover:text-brand-orange font-semibold transition">
                                                <FiDownload className="mr-2" /> Brochure
                                            </button>
                                        </div>

                                        <NavLink to={`/TopStudy-colleges`} state={{ state: item.link }} className="block w-full text-center bg-orange-50 text-brand-orange py-2 rounded-lg font-bold text-sm hover:bg-brand-orange hover:text-white transition mt-4">
                                            View Colleges <FiArrowRight className="inline ml-1" />
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {visibleCount < collegeData.length && (
                        <div className="text-center mt-12">
                            <button onClick={loadMoreCards} className="bg-white border border-gray-300 text-gray-600 px-8 py-3 rounded-full font-semibold hover:border-brand-orange hover:text-brand-orange transition shadow-sm">
                                Load More Colleges
                            </button>
                        </div>
                    )}
                </div>

                {/* Boucher Popup */}
                {showBoucherPopup && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                        <div className="bg-white rounded-2xl shadow-2xl relative w-full max-w-md max-h-[500px] overflow-y-auto">
                            <button
                                onClick={handleCloseBoucherPopup}
                                className="absolute top-3 right-3 text-gray-400 hover:text-gray-800 transition z-10"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            <Boucherpopup />
                        </div>
                    </div>
                )}

            </div>
        </section>
    );
};

export default UniversityGridSection;
